import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

function ContactPage() {
  return (
    <>
      <SEO
        title="Contact Us | KMC Health (Kitmeechai Health)"
        description="If you are interested in our digital healthcare solutions, feel free to contact us."
        path="/contact"
      />
      <div style={{ flex: 1 }}>
        <Contact />
      </div>
      <Footer />
    </>
  );
}

export default ContactPage;